import { generateRandomString } from "utils/random";
import { putCustomTab, removeCustomTab } from "api/storage";
import { setFlashMessageAction } from "actions/app-actions";

export const CUSTOM_TAB_CREATED = "actions/custom-tabs/custom-tab-created";
export const UPDATE_CUSTOM_TAB_NAME = "actions/custom-tabs/update-custom-tab-name";
export const START_DELETE_CUSTOM_TAB_MODE = "actions/custom-tabs/start-delete-custom-tab-mode";
export const END_DELETE_CUSTOM_TAB_MODE = "actions/custom-tabs/end-delete-custom-tab-mode";
export const CUSTOM_TAB_DELETED = "actions/custom-tabs/custom-tab-deleted";
export const CREATE_CUSTOM_TAB_LOADING = "actions/custom-tabs/create-custom-tab-loading";
export const CREATE_CUSTOM_TAB_LOADING_STOP = "actions/custom-tabs/create-custom-tab-loading-stop";
export const DELETE_CUSTOM_TAB_LOADING = "actions/custom-tabs/delete-custom-tab-loading";
export const DELETE_CUSTOM_TAB_LOADING_STOP = "actions/custom-tabs/delete-custom-tab-loading-stop";

export const createCustomTabAction = (accountId, tabFilters, tabName) => (dispatch) => {
  dispatch({ type: CREATE_CUSTOM_TAB_LOADING });
  const tabId = `${accountId}-${generateRandomString()}`;
  const customTab = {
    id: tabId,
    name: tabName,
    filters: tabFilters
  };
  return putCustomTab(customTab)
    .then(() => {
      dispatch({
        type: CUSTOM_TAB_CREATED,
        data: { customTab }
      });
      dispatch(setFlashMessageAction("Custom Tab Created"));
      dispatch({ type: CREATE_CUSTOM_TAB_LOADING_STOP });
    });
};

export const updateCustomTabNameAction = (name) => ({
  type: UPDATE_CUSTOM_TAB_NAME,
  data: { name }
});

export const startDeleteCustomTabModeAction = (id) => ({
  type: START_DELETE_CUSTOM_TAB_MODE,
  data: { id }
});

export const endDeleteCustomTabModeAction = () => ({
  type: END_DELETE_CUSTOM_TAB_MODE
});

export const deleteCustomTabAction = (id) => (dispatch) => {
  dispatch({ type: DELETE_CUSTOM_TAB_LOADING });
  return removeCustomTab(id)
    .then((response) => {
      dispatch({
        type: CUSTOM_TAB_DELETED,
        data: { customTabs: response }
      });
      dispatch({ type: DELETE_CUSTOM_TAB_LOADING_STOP });
      dispatch(setFlashMessageAction("Custom Tab Deleted", "error"));
    });
};



// WEBPACK FOOTER //
// ./src/js/actions/custom-tabs-actions.js